import React from 'react';
import { Link } from 'react-router-dom';

export default function CoursesDocs({ topic, setTopic, userInfo, schoolType }) {
	const isSupervisor = userInfo && `${userInfo.role_id}` === '3';
	const validTopics = ['search_courses', 'upload_courses', 'sort_courses', 'filter_by_department', 'add_course', 'edit_course', 'select_rows', 'delete_courses'].filter(topic_option => !isSupervisor || !['upload_courses', 'add_course'].includes(topic_option));
	const coursesTopic = validTopics.includes(topic) ? topic : 'default';

	const chooseCoursesTopic = (newTopic) => {
		if (coursesTopic === newTopic) {
			setTopic(null);
		} else {
			setTopic(newTopic);
		}
	};

	const videoPlaceholder = { backgroundColor: '#000', borderRadius: '8px', color: '#fff', minHeight: '240px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px', padding: '20px', textAlign: 'center' };

	return (
		<div className='documentation-page'>
			<div className='step-main-heading'>Courses</div>
			<p className='documentation-question-heading'>What do you need help with?</p>
			<div className='choose-topic'>
				<Link className={`choose-topic-btn ${coursesTopic === 'search_courses' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/courses/${coursesTopic === 'search_courses' ? 'null' : 'search_courses'}`} onClick={() => chooseCoursesTopic('search_courses')}>Search Courses</Link>
				{!isSupervisor && <Link className={`choose-topic-btn ${coursesTopic === 'upload_courses' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/courses/${coursesTopic === 'upload_courses' ? 'null' : 'upload_courses'}`} onClick={() => chooseCoursesTopic('upload_courses')}>Upload Courses</Link>}
				<Link className={`choose-topic-btn ${coursesTopic === 'sort_courses' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/courses/${coursesTopic === 'sort_courses' ? 'null' : 'sort_courses'}`} onClick={() => chooseCoursesTopic('sort_courses')}>Sort Course Data</Link>
				<Link className={`choose-topic-btn ${coursesTopic === 'filter_by_department' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/courses/${coursesTopic === 'filter_by_department' ? 'null' : 'filter_by_department'}`} onClick={() => chooseCoursesTopic('filter_by_department')}>Filter By Department</Link>
				{!isSupervisor && <Link className={`choose-topic-btn ${coursesTopic === 'add_course' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/courses/${coursesTopic === 'add_course' ? 'null' : 'add_course'}`} onClick={() => chooseCoursesTopic('add_course')}>Add A Course</Link>}
				<Link className={`choose-topic-btn ${coursesTopic === 'edit_course' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/courses/${coursesTopic === 'edit_course' ? 'null' : 'edit_course'}`} onClick={() => chooseCoursesTopic('edit_course')}>Edit A Course</Link>
				<Link className={`choose-topic-btn ${coursesTopic === 'select_rows' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/courses/${coursesTopic === 'select_rows' ? 'null' : 'select_rows'}`} onClick={() => chooseCoursesTopic('select_rows')}>Select Course Rows</Link>
				<Link className={`choose-topic-btn ${coursesTopic === 'delete_courses' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/courses/${coursesTopic === 'delete_courses' ? 'null' : 'delete_courses'}`} onClick={() => chooseCoursesTopic('delete_courses')}>Delete Courses</Link>
			</div>

			{coursesTopic === 'search_courses' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Search Courses</h2>
					<div className='documentation-step-text'>Use the search bar to quickly find courses by course name or course code.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{coursesTopic === 'upload_courses' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Upload Courses</h2>
					<div className='documentation-step-text'>Use the Upload button to open the Courses upload modal and import a file.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{coursesTopic === 'sort_courses' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Sort Course Data</h2>
					<div className='documentation-step-text'>Sort the table by Code, Course Name, or Priority from the column headers.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{coursesTopic === 'filter_by_department' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Filter By Department</h2>
					<div className='documentation-step-text'>Use the Department(s) filter in the header to narrow the list to selected departments.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{coursesTopic === 'add_course' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Add A Course</h2>
					<div className='documentation-step-text'>Click the plus button in the table header to create a new course.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{coursesTopic === 'edit_course' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Edit A Course</h2>
					<div className='documentation-step-text'>Click the edit icon on a row to update an existing course record.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{coursesTopic === 'select_rows' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Select Course Rows</h2>
					<div className='documentation-step-text'>Select individual rows or use Select All to prepare multiple courses for bulk actions.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{coursesTopic === 'delete_courses' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Delete Courses</h2>
					<div className='documentation-step-text'>Delete one or many selected courses, confirm removal, and optionally hide future delete prompts.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
		</div>
	);
}
